var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"object_detail",staticStyle:{"margin-right":"15px","margin-left":"15px"}},[_c('div',{staticClass:"object_detail"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.val))])])}
var staticRenderFns = []

export { render, staticRenderFns }